import "./AmountContainer.css";

export const AmountContainer = ({ children }) => {
  return <div className="amount-container stick">{children}</div>;
};
